import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-external-links.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-external-links.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../services/route-params.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { AppControllerService } from "../../../app-controller.service";
import { ApplicationExternalLinksConstants } from "./application-external-links.constants";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { aflaModuleServiceProvider } from "../../services/afla-module-strategy/afla-module-strategy.service.provider";
import { ApplicationExternalLinksService } from "./application-external-links.service";
import { SaLongDatePipe } from "../../pipes/sa-long-date/sa-long-date.pipe";
let ApplicationExternalLinksComponent = class ApplicationExternalLinksComponent extends ApplicationBaseComponent {
    applicationExternalLinksService;
    appController;
    changeDetectorRefs;
    aflaModuleStrategyService;
    routerParamsService;
    route;
    saLongDatePipe;
    busyFetching = false;
    category = ApplicationExternalLinksConstants.ARCGIS_ITEM_CATEGORY;
    externalLinks = [];
    getExternalLinksObservableSubscription;
    constructor(applicationExternalLinksService, appController, changeDetectorRefs, aflaModuleStrategyService, routerParamsService, route, saLongDatePipe) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.applicationExternalLinksService = applicationExternalLinksService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.routerParamsService = routerParamsService;
        this.route = route;
        this.saLongDatePipe = saLongDatePipe;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.fetchExternalLinks();
    }
    handleRouteChange() {
        this.fetchExternalLinks();
    }
    fetchExternalLinks() {
        if (this.jobID !== undefined && this.jobID !== null && !this.busyFetching) {
            this.busyFetching = true;
            this.getExternalLinksObservableSubscription = this.aflaModuleStrategyService.getExternalLinks(+this.moduleID, +this.jobID, this.category)
                .subscribe({
                next: (result) => {
                    if (result != null && result.length != 0) {
                        result.forEach(x => {
                            let decodedUrl = decodeURIComponent(x.link);
                            this.externalLinks.push({
                                id: x.id,
                                jobId: x.jobId,
                                moduleId: x.moduleId,
                                name: x.name,
                                category: x.category,
                                link: decodedUrl,
                                createdDate: this.saLongDatePipe.transform(x.createdDate)
                            });
                        });
                    }
                    this.changeDetectorRefs.detectChanges();
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ApplicationExternalLinksConstants.COMPONENT_NAME, error, CRUDOperation.Update);
                }
            });
        }
    }
    onItemClicked(url) {
        const decodedUrl = decodeURIComponent(url);
        window.open(decodedUrl, "_blank");
    }
    static ctorParameters = () => [
        { type: ApplicationExternalLinksService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService },
        { type: RouterParamsService },
        { type: ActivatedRoute },
        { type: SaLongDatePipe }
    ];
};
ApplicationExternalLinksComponent = __decorate([
    Component({
        selector: "app-application-external-links",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ApplicationExternalLinksComponent);
export { ApplicationExternalLinksComponent };
